import React, { Component, useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { DatePicker } from "@material-ui/pickers";
import { setactiveTabObj } from "../../redux/actions/appActions";
import { connect } from "react-redux";
import swal from "sweetalert";
import { useHistory, withRouter, Route, Redirect, Switch } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OffileDb from '../../config/pouchDB';
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@material-ui/icons/ThumbDownAltOutlined';
import Loader from "../loaders/loader";
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Calendarsetreminder from "./calendersetreminder.js";
import moment from 'moment';

var tempDates = [];
class UserSpecificList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      reminderList: [],
      editRemainderObj: null
    };
  }


  componentDidMount() {
    OffileDb.setDatabase()
    this.getRemiderList()
  }

  getRemiderList() {
    var that = this;
    OffileDb.getData('userReminderList').then(function (result) {
      console.log('52',result)
      if (!result.status && result.status != 400) {
        that.setState({ reminderList: result.data })
      }
      that.setState({ isLoading: false })
    })
  }



  alertError(err) {
    const { t } = this.props;
    swal({
      text: t(err),
      icon: "success",
      button: t("ok"),
    })
  }

  deleteReminder(obj) {
    const { t } = this.props;
    var that = this;

    swal({
      text: t("Are you sure want to delete this reminder"),
      icon: "warning",
      buttons: {
        confirm: {
          text: t("yes"),
          value: true,
          visible: true,
          className: "",
          closeModal: true
        },
        cancel: {
          text: t("no"),
          value: false,
          visible: true,
          className: "",
          closeModal: true,
        }
      }
    }).then((val) => {
      console.log(val)
      if (val) {
        var arr = this.state.reminderList;
        console.log(obj, arr)
        arr = arr.filter(function (e) {
          return e.id != obj.id;
        });
        that.setState({ reminderList: arr })
        OffileDb.setData('userReminderList', arr)
      }
    });

  }


  editReminder(obj) {
    console.log(obj)
    this.setState({ editRemainderObj: obj })
  }



  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { color: "#fff", background: this.props.componentbgcolor } : {};
    let colorStyles = templateID == 2 ? { color: this.props.componentbgcolor } : {};
    console.log('118',this.state.reminderList)
    return (
      <Grid container spacing={3} className="gridcontainer">
        <Calendarsetreminder editRemainderObj={this.state.editRemainderObj} handleClose={() => { this.getRemiderList() }}></Calendarsetreminder>
        {
            this.state.reminderList && this.state.reminderList.length > 0 ? (
            this.state.reminderList.map((obj) => {
              var startDate = moment(obj.startdDate).format('DD/MM/YYYY');
              var endDate = moment(obj.endDate).format('DD/MM/YYYY');
              var time = moment(obj.time, "HH:mm:ss").format("hh:mm A");
              return (
                <Grid item xs={12} className="informationcardholder">
                  <Card className="border-grey mt-10px noboxshadwo">
                    <CardContent className="zero">
                      <p className="zero settingcardheader getknwtitle" style={colorStyles}>{t(obj.title)}</p>
                      <p className="zero p-10px getknwsubtitle">{t('Start Date')}: {startDate}</p>
                      <p className="zero p-10px getknwsubtitle">{t('End Date')}: {endDate}</p>
                      <p className="zero p-10px getknwsubtitle">{t('Remindar Time')}: {time}</p>
                      <p className="zero p-10px getknwsubtitle">{t('frequency')}: {obj.frequency}</p>
                      <p className="zero p-10px pb-15px remindericonholder">
                        {
                          templateID == 1 ? (
                            <>
                              <IconButton aria-label="edit" className="p-0" onClick={() => { this.editReminder(obj) }}>
                                <EditIcon />
                              </IconButton>
                              <IconButton aria-label="delete" className="p-0" onClick={() => { this.deleteReminder(obj) }}>
                                <DeleteIcon />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <Button variant="contained" style={bgStyles} onClick={() => { this.deleteReminder(obj) }}>{t("Delete")}</Button>
                              <Button className="editReminderBtn" variant="contained" style={bgStyles} onClick={() => { this.editReminder(obj) }}>{t("Edit")}</Button>
                            </>
                          )
                        }

                      </p>
                    </CardContent>
                  </Card>
                </Grid>
              )
            })
          ) : (
            <div className="padding10 nodatafound">{t('No reminder found')}</div>
          )
        }
      </Grid>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    activeTabObj: storeState.activeTabObj,
    componentbgcolor: storeState.componentbgcolor
  };
};


const transSerives = withTranslation()(UserSpecificList);
const ThemeServices = withTheme(transSerives);
const routeServices = withRouter(ThemeServices);
export default connect(mapStateToProps, { setactiveTabObj })(routeServices);
